import Vue from 'vue'
import axios from 'axios'
import { getToken, removeToken } from '@/utils/token'

// 挂载到Vue原型
Vue.prototype.$axios = axios

// 因为我们现在的后台需要携带过去cookies,所以需要设置下允许携带cookies，不是每个后台都需要的
// axios.defaults.withCredentials = true // 允许携带cookie

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // baseURL: process.env.VUE_APP_BASE_API,
    baseURL: 'http://192.168.50.72:9002',
    // easy-mock服务挂了，暂时不使用了
    // baseURL: '/api',
    timeout: 5000
})
// 拦截器
service.interceptors.request.use(
    config => {
        const token = getToken()

        if (token) {
            config.headers.token = token
        }
        console.log('config:', config)
        return config
    },
    error => {
        console.log(error)
        return Promise.reject()
    }
)

service.interceptors.response.use(
    response => {
        // console.log(response)
        return response.data

        // if (response.code === 0) {
        // } else {
        //     Promise.reject()
        // }
    },
    error => {
        console.log(error)
        return Promise.reject()
    }
)

export default service
